/** The SDK-owned query-time bridge from a joined reads face to its model. */
import type { ModelRow, Option } from "@tento-lona/sheets";
import { liveRowOf } from "@tento-lona/sheets/internal-ui";
import type { SheetRow } from "./sheet-row.ts";

/** Internal read mechanism; not a public live-row or writer export. */
export function joinedLiveVariantOf(row: SheetRow.Joined.Handle): Option<ModelRow> {
  const face = row.variant;
  return face == null ? null : liveRowOf(face);
}
